import { IamGroupType, SmoketestPermissionLevel } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useMemo, useState } from 'react';

import { ApiErrorMessageInternal, TanstackFormAsyncSelect } from 'noddi-ui-web';
import { buildAssigneeOptions, renderAssigneeOption } from './assigneeOption';

type Props = {
  label?: string;
  placeholder?: string;
};

const ASSIGNEE_ROLES: SmoketestPermissionLevel[] = [
  SmoketestPermissionLevel.STAFF,
  SmoketestPermissionLevel.WORKER,
  SmoketestPermissionLevel.SUPERUSER
];
const ASSIGNEE_GROUP_TYPES: IamGroupType[] = [IamGroupType.PERSONAL];

export const TanstackTicketAssigneePicker = ({
  label = 'Assignee (optional)',
  placeholder = 'Search staff, workers, or superusers...'
}: Props) => {
  const [search, setSearch] = useState('');

  const { data, isFetching, error } = noddiAsync.useGet({
    type: URLKeys.getPaginatedUserGroups,
    input: { pageIndex: 0, pageSize: 20, search, roles: ASSIGNEE_ROLES, types: ASSIGNEE_GROUP_TYPES }
  });

  const options = useMemo(() => buildAssigneeOptions(data?.results ?? []), [data?.results]);

  if (error) {
    return <ApiErrorMessageInternal error={error} />;
  }

  return (
    <TanstackFormAsyncSelect<number>
      label={label}
      placeholder={placeholder}
      options={options}
      isLoading={isFetching}
      onSearch={setSearch}
      renderOption={renderAssigneeOption}
    />
  );
};
